import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { gsApi } from "../auth/auth";
import {
  organizations,
  discountCodes,
  getThunkResponse,
  deleteThunkResponse,
  saveThunkResponse,
  createThunkResponse,
} from "../app/api";
import {
  getOpts,
  getResponse,
  getSerializedData,
  shortDelay,
} from "../helpers/JSONapi";

//get
export const getOrganizationDiscountCodes = createAsyncThunk(
  "discounts/getOrganizationDiscountCodes",
  async (id, thunkAPI) => {
    const response = await gsApi.get(`${organizations}/${id}/discount-codes`);
    return response;
  }
);

export const getOrganizationDiscountCode = createAsyncThunk(
  "discounts/getOrganizationDiscountCode",
  async (id, thunkAPI) => {
    const response = await gsApi.get(`${discountCodes}/${id}`);
    return response;
  }
);
//delete

export const deleteOrganizationDiscount = createAsyncThunk(
  "discounts/deleteOrganizationDiscount",
  async (id, thunkAPI) => {
    const response = await gsApi.delete(`${discountCodes}/${id}`, {
      data: {},
    });
    return response;
  }
);

//save

export const saveOrganizationDiscount = createAsyncThunk(
  "discounts/saveDiscount",
  async (discount, thunkAPI) => {
    const serializedData = getSerializedData(
      discount,
      "discount-codes",
      getOpts(discount, getOrganizationRelationship(discount))
    );
    return await getResponse(
      gsApi.patch,
      `${discountCodes}/${discount.id}`,
      serializedData,
      thunkAPI
    );
  }
);

//add
export const addOrganizationDiscount = createAsyncThunk(
  "discounts/addOrganizationDiscount",
  async (discount, thunkAPI) => {
    const serializedData = getSerializedData(
      discount,
      "discount-codes",
      getOpts(discount, getOrganizationRelationship(discount))
    );
    return await getResponse(
      gsApi.post,
      `${discountCodes}`,
      serializedData,
      thunkAPI
    );
  }
);

export const discountSlice = createSlice({
  name: "discounts",
  initialState: {
    selectedOrganizationDiscountCodes: [],
    selectedDiscount: {},
    notifications: [],
    loading: [],
  },
  reducers: {
    setSelectedDiscount: (state, action) => {
      state.selectedDiscount = action.payload;
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
  extraReducers: {
    ...getThunkResponse(getOrganizationDiscountCodes, (state, action) => {state.selectedOrganizationDiscountCodes = action.payload;}),
    ...getThunkResponse(getOrganizationDiscountCode, (state, action) => {state.selectedDiscount = action.payload;}),
    ...deleteThunkResponse(deleteOrganizationDiscount, (state, action) => {
      const filteredList = state.selectedOrganizationDiscountCodes?.filter?.(
        (discount) => discount.id !== action.meta.arg
      );
      state.selectedOrganizationDiscountCodes = filteredList;
    }, "Discount", shortDelay),
    ...saveThunkResponse(saveOrganizationDiscount, (state, action) => {
      state.selectedDiscount = action.payload;
      const index = state.selectedOrganizationDiscountCodes?.findIndex?.(
        (discount) => discount.id === action.payload.id
      );
      state.selectedOrganizationDiscountCodes[index] = action.payload;
    }, "Discount", shortDelay),
    ...createThunkResponse(addOrganizationDiscount, (state, action) => {
      state.selectedOrganizationDiscountCodes = [
        action.payload,
        ...state.selectedOrganizationDiscountCodes,
      ];
      state.selectedDiscount = action.payload;
    }, "Discount", shortDelay),
  },
});

export const { setSelectedDiscount, clearNotifications } = discountSlice.actions;

export const selectOrganizationDiscountCodes = (state) =>
  state.discounts.selectedOrganizationDiscountCodes;

export const selectDiscountNotifications = (state) =>
  state.discounts.notifications;

export const selectDiscount = (state) => state.discounts.selectedDiscount;

export const selectLoading = (state) => state.discounts.loading;

export default discountSlice.reducer;

function getOrganizationRelationship() {
  const relationships = [];
  relationships.push({
    name: "organization",
    opt: { ref: "id", included: true },
  });
  return relationships;
}
